import { AgreementStatus } from "../../../shared/services/api/sinister/SinisterAgreementService";

export const AGREEMENT_STATUS_OPTIONS: { value: AgreementStatus; label: string }[] = [
	{ value: "overdue", label: "Atrasado" },
	{ value: "on_time", label: "Em dia" },
	{ value: "preventive", label: "Preventiva" },
	{ value: "broken", label: "Quebra de acordo" },
	{ value: "paid_off", label: "Quitado" },
	{ value: "renegotiated", label: "Reparcelado" },
];

// Normaliza pra minúsculo antes de comparar — o backend às vezes manda o valor com case diferente
// (mesmo padrão de bug já visto/corrigido em negotiationStatusOptions.ts), o que fazia o chip cair no
// fallback e mostrar o valor cru em vez do rótulo traduzido.
const normalize = (status: string): string => (status ?? "").toLowerCase();

export const getAgreementStatusLabel = (status: AgreementStatus | string): string =>
	AGREEMENT_STATUS_OPTIONS.find((option) => option.value === normalize(status))?.label ?? status;

// Paleta pastel alinhada ao padrão já usado em Garantias (globalbackgroundProposal/globalColorTextProposal).
export const getAgreementStatusChipColors = (status: AgreementStatus | string): { bg: string; color: string } => {
	switch (normalize(status)) {
		case "on_time":
			return { bg: "#e9f8f5", color: "#43b897" };
		case "overdue":
			return { bg: "#fff4e5", color: "#ed6c02" };
		case "paid_off":
			return { bg: "#e0faff", color: "#0f92d4" };
		case "broken":
			return { bg: "#fcedea", color: "#e36b5b" };
		case "preventive":
			return { bg: "#f1e9fc", color: "#8a4fd1" };
		case "renegotiated":
			return { bg: "#fff9e0", color: "#c9a300" };
		default:
			return { bg: "#ECECEC", color: "#757575" };
	}
};
